import SuiBox from '@upheal/design-system/components/legacy/Sui/SuiBox';
import PageLayout, { Props as PageLayoutProps } from './PageLayout';
import { Card, SxProps, Theme, useMediaQuery, useTheme } from '@mui/material';
import Footer from './Footer';
import LogoBox from '../LogoBox';

export const CARD_WIDTH = '90%';
export const MAX_CARD_WIDTH = 400;

const CardPageLayout = ({
    children,
    colorTheme = 'light',
    backgroundImage,
    showFooter = false,
    showLogo = true,
    logoPosition = 'middle',
    cardSx,
    pageLayoutProps,
    contentUnderCard,
}: {
    children: React.ReactNode;
    colorTheme?: 'light' | 'dark';
    backgroundImage?: string;
    showFooter?: boolean;
    showLogo?: boolean;
    logoPosition?: 'top-left' | 'middle';
    cardSx?: SxProps<Theme>;
    pageLayoutProps?: PageLayoutProps;
    contentUnderCard?: React.ReactNode;
}) => {
    const theme = useTheme();
    const position =
        useMediaQuery(theme.breakpoints.down('sm')) || logoPosition === 'middle'
            ? 'middle'
            : 'top-left';

    return (
        <PageLayout
            background={colorTheme === 'light' ? 'default' : 'gradient'}
            backgroundImage={backgroundImage}
            display="flex" // this way the child box can have 100% height
            {...pageLayoutProps}
        >
            <SuiBox
                width="100%"
                minHeight="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={3}
            >
                {showLogo && position === 'middle' && (
                    <>
                        <SuiBox pt={2}>
                            <LogoBox colorTheme={colorTheme} />
                        </SuiBox>
                        <SuiBox
                            maxHeight="48px"
                            minHeight="16px"
                            flexGrow={0.2}
                        />
                    </>
                )}
                {showLogo && position === 'top-left' && (
                    <SuiBox
                        position="absolute"
                        top={0}
                        left={0}
                        pt={4}
                        pl={7.5}
                        display="flex"
                        alignItems="center"
                    >
                        <LogoBox colorTheme={colorTheme} />
                    </SuiBox>
                )}
                <Card
                    sx={{
                        width: CARD_WIDTH,
                        maxWidth: MAX_CARD_WIDTH,
                        p: {
                            xs: 3,
                            sm: 4,
                        },
                        ...cardSx,
                    }}
                >
                    {children}
                </Card>
                {contentUnderCard}
                {showFooter && (
                    <>
                        <SuiBox
                            maxHeight="48px"
                            minHeight="12px"
                            flexGrow={0.2}
                        />
                        <Footer
                            color={theme.palette.gradientBackground.textColor}
                        />
                    </>
                )}
            </SuiBox>
        </PageLayout>
    );
};

export default CardPageLayout;
